import React, { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { fetchAndLogoutKeycloak } from 'app/modules/keycloak/keycloak';
import { Loader } from 'app/shared/loader/loader';

export const Logout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchAndLogoutKeycloak();
    if (location.pathname === '/logout') {
      navigate('/');
    }
  }, []);

  return <Loader />;
};

export default Logout;
